import { render, staticRenderFns } from "./OrderTimeline.vue?vue&type=template&id=54a0915c&scoped=true&"
import script from "./OrderTimeline.vue?vue&type=script&lang=js&"
export * from "./OrderTimeline.vue?vue&type=script&lang=js&"
import style0 from "./OrderTimeline.vue?vue&type=style&index=0&id=54a0915c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a0915c",
  null
  
)

export default component.exports